module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/desktop-500@2x_1ddb97.jpg";